<style lang="less" scoped>
  @import "../../../style/theme.less";

  h1 {
    font-family: "Kaushan Script", cursive;
    font-weight: 400;
    font-size: 28px;
  }

  .spinner {
    width: 100%;
    height: 64px;
    margin: 48px 0;
    color: @primary-color;
  }
</style>

<template>
  <div>
    <a-row type="flex">
      <a-col flex="auto">
        <h1>Your Archetype Is...</h1>
      </a-col>
      <a-col flex="50px" v-if="!loading">
        <a-button
          type="primary"
          shape="circle"
          icon="download"
          @click="downloadReport"
        />
      </a-col>
    </a-row>
    <a-spin
      size="large"
      class="spinner"
      tip="Generating your report..."
      :spinning="loading"
    >
      <a-icon slot="indicator" type="loading" style="font-size: 48px; margin-bottom: 24px" spin />
    </a-spin>

    <div v-if="!loading">
      <div v-for="block in reportBlocks" :key="block.id" v-html="block.content"/>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { getErrorMessage } from '../../../lib/utils';

export default {
  name: 'user.report',

  data: () => ({
  }),

  mounted() {
    if (!this.licenseKey) {
      return this.returnHome();
    }

    return this.getReportBlocks()
      .catch(e => {
        this.error(e);
      });
  },

  computed: mapState('user', ['licenseKey', 'reportBlocks', 'loading',]),

  methods: {
    ...mapActions('user', ['getReportBlocks',]),

    downloadReport() {
      return window.open(`/reports/pdf/${this.licenseKey}`);
    },

    returnHome() {
      return this.$router.replace({ name: 'user.landing', });
    },

    error(e) {
      return this.$error({
        title: 'Something went wrong',
        content: (
          <div>
            <p>{ getErrorMessage(e) }</p>
            <p>If this keeps happening, please reach out to us <a href="https://goddessgift.com/contact/" target="_blank">here</a></p>
          </div>
        ),
        onOk: this.returnHome,
      });
    },
  },
};
</script>
